// A page's own single keys: / to its search, N for its New on a list, R to
// record from Home and Meetings, ? for this list. Same guards as every bare
// key (./shortcuts). Renders nothing but the list.

import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { Kbd } from "@/components/ui/Kbd";
import { Modal } from "@/components/ui/Modal";

import { JUMP_HINT, newPathFor, recordKeyAt, useShortcut } from "./shortcuts";

const KEYS: readonly [string, string][] = [
  [JUMP_HINT, "Jump to anything"],
  ["/", "Search this page"],
  ["N", "New, on a list"],
  ["R", "Record a meeting, on Home and Meetings"],
  ["[", "Hide the sidebar"],
  ["?", "These keys"],
];

function focusSearch() {
  const box = document.querySelector<HTMLInputElement>("main input[type='search'], main input[aria-label^='Search'], main input[placeholder^='Search']");
  box?.focus();
  box?.select();
}

export function PageKeys() {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const newPath = newPathFor(pathname, search);
  useShortcut("/", focusSearch);
  useShortcut("n", () => newPath && navigate(newPath), !!newPath);
  useShortcut("r", () => navigate("/record"), recordKeyAt(pathname));
  useShortcut("?", () => setOpen(true), true, true);
  if (!open) return null;
  return (
    <Modal open onClose={() => setOpen(false)} title="Keys" size="sm">
      <dl className="flex flex-col gap-2 text-sm">
        {KEYS.map(([key, what]) => (
          <div key={key} className="flex items-center justify-between gap-4">
            <dt className="text-fg-muted">{what}</dt>
            <dd>
              <Kbd>{key}</Kbd>
            </dd>
          </div>
        ))}
      </dl>
    </Modal>
  );
}
